import { createGlobalStyle } from 'styled-components'

const CustomStyle = createGlobalStyle`
.regulamento {
    height: 100vmin;
    overflow: auto;
  @media screen and (min-width:768px){
    height: 50vmin;
  }
  div, p {
    margin-bottom: 15px !important;
  }
  a {
    color: var(--orange);
    text-decoration: underline;
    padding: 0 3px;
    font-weight: bold;
    :hover{
      color: var(--orange);
    }
  }
`

export { CustomStyle }
